/******************************
 * ARASO Theme Fixes
 * コレクションページのリンクが2〜3秒押せない問題を完全修正するパッチ
 ******************************/

// ===== PATCH 1: asyncCSS を即時ロード化 =====
window.addEventListener('load', function() {
  if (typeof asyncCSS === 'function') {
    asyncCSS();
  }
});

// ===== PATCH 2: 初期化時のクリックロック解除 =====
document.addEventListener("DOMContentLoaded", function() {
  document.documentElement.style.pointerEvents = "auto";
});

window.addEventListener("load", function() {
  document.documentElement.style.pointerEvents = "auto";
});

// 遅延解除（Masonryが遅いページ対策）
setTimeout(() => {
  document.documentElement.style.pointerEvents = "auto";
}, 1000);

// ===== PATCH 3: a.toggle の初期 preventDefault をリセット =====
window.addEventListener('load', function() {
  const toggles = document.querySelectorAll('a.toggle');
  toggles.forEach(el => {
    const clone = el.cloneNode(true);
    el.parentNode.replaceChild(clone, el);
  });
});

// ===== PATCH 4: t1cl 遷移遅延の完全無効化 =====
const htmlEl = document.documentElement;

// t1cl が付与されても即削除してロックを殺す
const observer = new MutationObserver(() => {
  if (htmlEl.classList.contains('t1cl')) {
    htmlEl.classList.remove('t1cl');
    htmlEl.style.pointerEvents = "auto"; // 保険
  }
});

observer.observe(htmlEl, { attributes: true, attributeFilter: ['class'] });

// ページロード時も念のため削除
window.addEventListener('load', () => {
  htmlEl.classList.remove('t1cl');
  htmlEl.style.pointerEvents = "auto";
});
